export const auspiciousTypes = [
  {
    en: 'New Wallet',
    th: 'ฤกษ์กระเป๋าสตางค์',
    value: 'new_wallet',
  },
  {
    en: 'Examination',
    th: 'ฤกษ์สอบ',
    value: 'exam',
  },
  {
    en: 'Marriage',
    th: 'Wedding ceremony',
    value: 'marriage',
  },
  {
    en: 'Marriage registration',
    th: 'ฤกษ์จดทะเบียนสมรส',
    value: 'marriage_registration',
  },
  {
    en: 'New Car',
    th: 'ฤกษ์ออกรถ',
    value: 'new_car',
  },
  {
    en: 'Childbirth',
    th: 'ฤกษ์คลอดบุตร',
    value: 'birth',
  },
  {
    en: 'Move-in day',
    th: 'ฤกษ์ขึ้นบ้านใหม่',
    value: 'house_moving',
  },
  {
    en: 'Groundbreaking for general buildings',
    th: 'ฤกษ์ลงเสาเอกอาคารทั่วไป',
    value: 'non_residential_construction',
  },
  {
    en: 'Groundbreaking for house',
    th: 'ฤกษ์ลงเสาเอกบ้าน',
    value: 'residential_construction',
  },
  {
    en: 'Business opening',
    th: 'ฤกษ์เปิดธุรกิจใหม่',
    value: 'business_opening',
  },
  {
    en: 'Contract signing',
    th: 'ฤกษ์เซ็นสัญญา',
    value: 'contract_signing',
  },
  {
    en: 'Aesthetic surgery',
    th: 'ฤกษ์ศัลยกรรมความงาม',
    value: 'cosmetic_surgery',
  },
  {
    en: 'Medical surgery',
    th: 'ฤกษ์ผ่าตัดทั่วไป',
    value: 'surgery',
  },
  {
    en: 'Medical treatment',
    th: 'ฤกษ์รักษาโรค',
    value: 'treatment',
  },
  {
    en: 'GIFT or ICSI procedures',
    th: 'ฤกษ์ทำกิฟต์หรือ ICSI',
    value: 'gift_icsi',
  },
  {
    en: 'Cosmetic procedures',
    th: 'ฤกษ์เสริมความงาม',
    value: 'beauty',
  },
  {
    en: 'Studying abroad',
    th: 'ฤกษ์เดินทางเรียนต่อต่างประเทศ',
    value: 'study_abroad',
  },
  {
    en: 'Pet adoption',
    th: 'ฤกษ์รับสัตว์เลี้ยง',
    value: 'new_pet',
  },
  {
    en: 'Product launch',
    th: 'ฤกษ์เปิดตัวสินค้า',
    value: 'product_launch',
  },
]

export const auspiciousStatus = [
  {
    en: 'All Status',
    th: 'All Status',
    value: '',
    color: '#000000',
  },
  {
    en: 'Select Date',
    th: 'ต้องการวัน',
    value: 'auto_date_selecting',
    color: '#CC0100',
  },
  {
    en: 'Select Date',
    th: 'ต้องการวัน',
    value: 'date_selecting',
    color: '#CC0100',
  },
  {
    en: 'Waiting user to confirm',
    th: 'รอผู้ใช้ยืนยัน',
    value: 'date_confirming',
    color: '#FFBA00',
  },
  {
    en: 'Select Remaining Date',
    th: 'ต้องการเวลา',
    value: 'completing',
    color: '#F47036',
  },
  {
    en: 'Completed',
    th: 'สำเร็จ',
    value: 'completed',
    color: '#28BF7A',
  },
]

export const surgeryTypes = {
  other: 'Others',
  nose: 'Nose Surgery',
  eyes: 'Eye Surgery',
  mouth: 'Lip Surgery',
  face: 'Facial Reconstruction Surgery',
  chest: 'Breast Surgery',
  filler: 'Filler',
  botox: 'Botox',
  facial_bright_injection: 'Facial bright injection',
  meso_fat: 'Meso fat',
  intravenous_vitamin_therapy: 'Intravenous Vitamin therapy',
}
